import { createContext, useState } from "react";
import { Outlet } from "react-router-dom";

const LayoutContext = createContext();
export default LayoutContext;

export const LayoutContextProvider = ({ children }) => {
  const defaultTheme = window.localStorage.getItem("theme");
  const [openSidebar, setOpenSidebar] = useState(true);
  const [theme, setTheme] = useState(defaultTheme || "Dark");

  const context = {
    openSidebar,
    setOpenSidebar,
    theme,
    changeTheme: (selectedTheme) => {
      setTheme(selectedTheme);
      window.localStorage.setItem("theme", selectedTheme);
    },
  };
  return (
    <LayoutContext.Provider value={context}>
      <Outlet />
    </LayoutContext.Provider>
  );
};
